// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grey-0": "#fff",
	"grey-50": "#f7f7f7",
	"grey-100": "#e9e9e9",
	"grey-200": "#d2d2d2",
	"grey-300": "#b9b9b9",
	"grey-400": "#9f9f9f",
	"grey-500": "#878787",
	"grey-600": "#666",
	"grey-700": "#454545",
	"grey-800": "#282828",
	"grey-900": "#000",
	"pink-50": "#ffe5f5",
	"pink-100": "#ffb3e1",
	"pink-200": "#ff80ce",
	"pink-300": "#ff4cba",
	"pink-400": "#ff1aa6",
	"pink-500": "#e5008d",
	"pink-600": "#b2006e",
	"pink-700": "#80004e",
	"pink-800": "#4d002f",
	"pink-900": "#1a0010",
	"red-50": "#ffe5ea",
	"red-100": "#ffb2bf",
	"red-200": "#ff8095",
	"red-300": "#ff4d6a",
	"red-400": "#ff1a40",
	"red-500": "#e50026",
	"red-600": "#b2001e",
	"red-700": "#7d0015",
	"red-800": "#4d000d",
	"red-900": "#330009",
	"orange-50": "#ffeee5",
	"orange-100": "#ffccb2",
	"orange-200": "#ffaa80",
	"orange-300": "#ff884d",
	"orange-400": "#ff661a",
	"orange-500": "#e54d00",
	"orange-600": "#b23c00",
	"orange-700": "#7d2a00",
	"orange-800": "#4d1a00",
	"orange-900": "#310",
	"yellow-50": "#fffad6",
	"yellow-100": "#fff4ad",
	"yellow-200": "#ffef85",
	"yellow-300": "#ffea61",
	"yellow-400": "#ffe53d",
	"yellow-500": "#ffde0a",
	"yellow-600": "#e5c700",
	"yellow-700": "#a89500",
	"yellow-800": "#5c5000",
	"yellow-900": "#332c00",
	"citron-50": "#f6ffe5",
	"citron-100": "#e5ffb2",
	"citron-200": "#d4ff80",
	"citron-300": "#c3ff4d",
	"citron-400": "#b2ff1a",
	"citron-500": "#99e500",
	"citron-600": "#77b200",
	"citron-700": "#537d00",
	"citron-800": "#334d00",
	"citron-900": "#230",
	"green-50": "#eaffe5",
	"green-100": "#bfffb2",
	"green-200": "#95ff80",
	"green-300": "#6aff4d",
	"green-400": "#40ff1a",
	"green-500": "#26e500",
	"green-600": "#1eb200",
	"green-700": "#157d00",
	"green-800": "#0d4d00",
	"green-900": "#093300",
	"teal-50": "#daf5f6",
	"teal-100": "#b0eaed",
	"teal-200": "#87dee4",
	"teal-300": "#5dd3da",
	"teal-400": "#34c8d1",
	"teal-500": "#27a3aa",
	"teal-600": "#1d7b81",
	"teal-700": "#145357",
	"teal-800": "#0a2c2e",
	"teal-900": "#010404",
	"cyan-50": "#e5f6ff",
	"cyan-100": "#b2e5ff",
	"cyan-200": "#80d5ff",
	"cyan-300": "#4dc3ff",
	"cyan-400": "#1ab2ff",
	"cyan-500": "#0099e5",
	"cyan-600": "#0077b2",
	"cyan-700": "#00537d",
	"cyan-800": "#00334d",
	"cyan-900": "#023",
	"cyan-gradient-50": "#0077b3 linear-gradient(38deg,#0077c8,#34c8e6)",
	"cyan-gradient-100": "#0077b3 linear-gradient(38deg,#0077c9,#34c8e7)",
	"cyan-gradient-200": "#0077b3 linear-gradient(38deg,#0077b0,#34c8e8)",
	"cyan-gradient-300": "#0077b3 linear-gradient(38deg,#0077b1,#34c8e9)",
	"cyan-gradient-400": "#0077b3 linear-gradient(38deg,#0077b2,#34c8d0)",
	"cyan-gradient-500": "#0077b3 linear-gradient(38deg,#0077b3,#34c8d1)",
	"cyan-gradient-600": "#0077b3 linear-gradient(38deg,#0077b4,#34c8d2)",
	"cyan-gradient-700": "#0077b3 linear-gradient(38deg,#0077b5,#34c8d3)",
	"cyan-gradient-800": "#0077b3 linear-gradient(38deg,#0077b6,#34c8d4)",
	"cyan-gradient-900": "#0077b3 linear-gradient(38deg,#0077b7,#34c8d5)",
	"blue-50": "#e5eaff",
	"blue-100": "#b2bfff",
	"blue-200": "#8095ff",
	"blue-300": "#4d6aff",
	"blue-400": "#1a40ff",
	"blue-500": "#0026e5",
	"blue-600": "#001eb2",
	"blue-700": "#00157d",
	"blue-800": "#000d4d",
	"blue-900": "#000933",
	"indigo-50": "#eee5ff",
	"indigo-100": "#ccb3ff",
	"indigo-200": "#aa80ff",
	"indigo-300": "#884dff",
	"indigo-400": "#661aff",
	"indigo-500": "#4d00e6",
	"indigo-600": "#3c00b3",
	"indigo-700": "#2a007d",
	"indigo-800": "#1a004d",
	"indigo-900": "#103",
	"purple-50": "#fbe5ff",
	"purple-100": "#f3b2ff",
	"purple-200": "#eb80ff",
	"purple-300": "#e24dff",
	"purple-400": "#da1aff",
	"purple-500": "#c100e5",
	"purple-600": "#9600b2",
	"purple-700": "#69007d",
	"purple-800": "#40004d",
	"purple-900": "#2b0033",
	"opaque-50": "hsla(0,0%,100%,.051)",
	"opaque-100": "hsla(0,0%,100%,.102)",
	"opaque-200": "hsla(0,0%,100%,.2)",
	"opaque-300": "hsla(0,0%,100%,.302)",
	"opaque-400": "hsla(0,0%,100%,.4)",
	"opaque-500": "hsla(0,0%,100%,.502)",
	"opaque-600": "hsla(0,0%,100%,.6)",
	"opaque-700": "hsla(0,0%,100%,.702)",
	"opaque-800": "hsla(0,0%,100%,.8)",
	"opaque-900": "hsla(0,0%,100%,.902)",
	"npo-brand-50": "#fff3ea",
	"npo-brand-100": "#ffe2cb",
	"npo-brand-200": "#ffcba4",
	"npo-brand-300": "#ffb075",
	"npo-brand-400": "#ff9544",
	"npo-brand-500": "#ff7e1d",
	"npo-brand-600": "#ff6d00",
	"npo-brand-700": "#ff6d00",
	"npo-brand-800": "#df6000",
	"npo-brand-900": "#cb5700",
	"eerst-dit-brand-50": "#fff7e0",
	"eerst-dit-brand-100": "#ffe9ad",
	"eerst-dit-brand-200": "#ffdb7a",
	"eerst-dit-brand-300": "#ffcd46",
	"eerst-dit-brand-400": "#ffc014",
	"eerst-dit-brand-500": "#e0a400",
	"eerst-dit-brand-600": "#ad7f00",
	"eerst-dit-brand-700": "#7a5900",
	"eerst-dit-brand-800": "#473400",
	"eerst-dit-brand-900": "#140f00",
	"whatsapp-brand-50": "#fbfefc",
	"whatsapp-brand-100": "#cff7de",
	"whatsapp-brand-200": "#a4efc0",
	"whatsapp-brand-300": "#78e7a2",
	"whatsapp-brand-400": "#4de084",
	"whatsapp-brand-500": "#25d366",
	"whatsapp-brand-600": "#1ea952",
	"whatsapp-brand-700": "#167e3d",
	"whatsapp-brand-800": "#0e5228",
	"whatsapp-brand-900": "#072713",
	"clubhouse-brand-50": "#f9f1fe",
	"clubhouse-brand-100": "#e4c2f9",
	"clubhouse-brand-200": "#d094f5",
	"clubhouse-brand-300": "#9d65f0",
	"clubhouse-brand-400": "#7f37ec",
	"clubhouse-brand-500": "#6515dd",
	"clubhouse-brand-600": "#4f10ac",
	"clubhouse-brand-700": "#390c7e",
	"clubhouse-brand-800": "#24084f",
	"clubhouse-brand-900": "#0f0321",
	"transparent": "transparent",
	"white": "#fff",
	"black": "#000",
	"primary": "#ff661a",
	"secondary": "#ffde0a",
	"signal": "#ff1a40",
	"npo": "#ff6d00",
	"eerst-dit": "#ffcd46",
	"clubhouse": "#6515dd",
	"whatsapp": "#25d366",
	"link": "#69007d",
	"facebook": "#3b5998",
	"twitter": "#1da1f2",
	"tiktok": "#000",
	"spotify": "#1db954",
	"soundcloud": "#fe5000",
	"snapchat": "#fffc00",
	"youtube": "red",
	"vimeo": "#19b7ea",
	"instagram": "#dd2a7b"
};
module.exports = ___CSS_LOADER_EXPORT___;
